module.exports = __webpack_public_path__ + "img/IMG_0201.1eb20b03.jpg";